import { FormFieldSelectNG } from '../../Form'
import { FormikField, getFormikFormFieldErrorProps } from '../../Formik'
import { PhoneSelect } from '../PhoneSelect'

import { getPhoneSelectFieldValidValue } from './PhoneSelectFormikField.utils'

function PhoneSelectFormikField(props) {
  return (
    <FormikField
      {...props}
      withEntityCreationFromSearchValue
      Component={FormFieldSelectNG}
      Select={PhoneSelect}
      getErrorProps={getFormikFormFieldErrorProps}
      getValidValue={getPhoneSelectFieldValidValue}
    />
  )
}

export default PhoneSelectFormikField
